export default {
	states: {
		contentHeight: 0,
		mainHeight: 0
	},
	mutations: {
		setContentHeight(state, height) {
			state.contentHeight = height
		},
		setMainHeight(state, height) {
			state.mainHeight = height
		}
	}
}
